import React from 'react'
import UserCard from './UserCard.jsx'

const Beccy = () =>
  <UserCard
    name="Beccy"
    title="Office Manager"
    dyk="Beccy firmly believes that gin is a health drink &amp; the garnish counts towards your five a day. She also has far too many sparkly shoes from Irregular Choice."
  >
    <p>
      When not wrangling unicorns and generally keeping everything under
      control at LFH Towers, Beccy is most likely to be found in the great
      outdoors enjoying one of her eclectic hobbies. From being down a muddy
      hole on an archaeological dig to wandering round the grounds of a
      stately home dressed up as one of its previous inhabitants, to
      mudlarking on the River Thames. She's been a volunteer for the National
      Trust at Cliveden for over 10 years, loves a long distance walk, can
      bake a mean cake AND make it look pretty. She always has her nose in a
      book and takes far too many photos of everything!
    </p>
  </UserCard>

export default Beccy